import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Section, SectionContent, SectionHeader } from 'src/shared/components';

import ContactForm from './components/ContactForm/ContactForm';
import ContactInfoList from './components/ContactInfoList/ContactInfoList';
import styles from './ContactSection.module.scss';

const ContactSection = () => {
	const { t } = useTranslation();

	return (
		<Section name="contact" animation="fadeIn" classes={{ section: styles.section }}>
			<SectionHeader title={t('contactSection.title')} description={t('contactSection.description')} />
			<SectionContent componentRoot={Fragment} animation="fadeInUp">
				<ContactForm />
				<ContactInfoList />
			</SectionContent>
		</Section>
	);
};

export default ContactSection;
